import { BASE_URL, INDIAN_MSME_USER_TOKEN } from "../../utils/Constants";
import { RootState } from "..";
import axios from "axios";
import { ThunkAction } from "redux-thunk";
import OrderType, {
  CancelOrder,
  GetBuyerInvoice,
  GetOrder,
  GetOrderDetails,
  GetOrderInvoice,
  GetPOOrder,
  GetUserOrder,
  OrderAcceptance,
  orderReceived,
  UpdateOrderStatus,
} from "../types/OrderType";
import LogoutAction from "./LogoutAction";
import { getCookie } from "../../utils/CookieAction";
interface Action {
  type: string;
  payload?: any;
  message?: string;
}

const OrderAction = {
  getMyOrders:
    (data: GetOrder): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getOrderData: any = await axios.post(
          BASE_URL + "myOrder/list",
          {
            search: data.search,
            limit: data.limit,
            page: data.page,
            order_status: data.myOrderStatus,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        console.log(getOrderData);

        dispatch({
          type: OrderType.SET_ORDER_LIST,
          payload: {
            data: getOrderData.data.data.data,
            currentPage: getOrderData.data.data.current_page,
            lastPage: getOrderData.data.data.last_page,
            totalData: getOrderData.data.data.total,
            from: getOrderData.data.data.from,
            to: getOrderData.data.data.to,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getMyOrderDetails:
    (data: GetOrderDetails): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getOrderData: any = await axios.get(
          BASE_URL + "myOrder/detail/" + data.orderId,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: OrderType.SET_ORDER_DETAILS,
          payload: getOrderData.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getOrders:
    (data: GetUserOrder): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getOrderData: any = await axios.post(
          BASE_URL + "orders/fetch/" + data.orderStatus,
          {
            search: data.search,
            limit: data.limit,
            page: data.page,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: OrderType.SET_USER_ORDER_LIST,
          payload: {
            data: getOrderData.data.data.data,
            currentPage: getOrderData.data.data.current_page,
            lastPage: getOrderData.data.data.last_page,
            totalData: getOrderData.data.data.total,
            from: getOrderData.data.data.from,
            to: getOrderData.data.data.to,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  cancelOrder:
    (data: CancelOrder): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        await axios.post(
          BASE_URL + "myOrder/cancel/" + data.id,
          {
            reason: data.reason,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: OrderType.CANCEL_ORDER,
          payload: data.id,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  updateOrder:
    (data: UpdateOrderStatus): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        await axios.post(
          BASE_URL + "orders/status",
          {
            id: data.id,
            delivery_status: data.status,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: OrderType.DELIVERY_ORDER_STATUS,
          payload: data.id,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getOrderDetails:
    (data: GetOrderDetails): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getOrderData: any = await axios.get(
          BASE_URL + "orders/detail/" + data.orderId,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: OrderType.SET_ORDER_DETAILS,
          payload: getOrderData.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  orderAcceptance:
    (data: OrderAcceptance): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        await axios.get(
          BASE_URL + `orders/orderAcceptance/${data.id}/${data.status}`,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: OrderType.ORDER_ACCEPTANCE,
          payload: {
            orderId: data.id,
            status: data.status,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  getOrderInvoice:
    (data: GetOrderInvoice): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getOrderData: any = await axios.get(
          BASE_URL + "orders/invoice/" + data.id,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: OrderType.SET_ORDER_INVOICE,
          payload: getOrderData.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  getPOOrders:
    (data: GetPOOrder): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getOrderData: any = await axios.post(
          BASE_URL + "po/orders/",
          {
            search: data.search,
            limit: data.limit,
            page: data.page,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: OrderType.SET_PO_ORDER,
          payload: {
            data: getOrderData.data.data.data,
            currentPage: getOrderData.data.data.current_page,
            lastPage: getOrderData.data.data.last_page,
            totalData: getOrderData.data.data.total,
            from: getOrderData.data.data.from,
            to: getOrderData.data.data.to,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  getRecentOrders:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.get(BASE_URL + "orders/recent", {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
          },
        });

        dispatch({
          type: OrderType.GET_RECENT_ORDERS,
          payload: {
            data: result.data.data.products,
            totalTax: result.data.data.totalTax,
            grandTotal: result.data.data.grandTotal,
            totalQty: result.data.data.totalQty,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  myOrderReceived:
    (data: orderReceived): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.get(
          BASE_URL + "myOrder/status/" + data.id,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: OrderType.MY_ORDER_RECEIVED,
          payload: data.id,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  getBuyerInvoice:
    (data: GetBuyerInvoice): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      console.log("sample", BASE_URL + "orders/buyer-invoice/" + data.id);
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getOrderData: any = await axios.get(
          BASE_URL + "orders/buyer-invoice/" + data.id,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: OrderType.SET_BUYER_INVOICE,
          payload: getOrderData.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
};

export default OrderAction;
